import { useCompanyFormContext } from '@/components/Companies/CompaniesFormProvider';
import CompanyFooter from '@/components/Companies/CompanyFooter';
import CompaniesReportForm from '@/components/Companies/CompanyReportForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { useCompanyReportConfig } from '@/core/domain/enterprise/Companies/CompaniesReportConfig/CompaniesReportConfig.hooks';
import { CompanyReportFormValues } from '@/core/domain/reports/company/Company.types';
import { PageProps } from '@/types/PageProps';
import { Form, Skeleton } from 'antd';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

const CompanyReportPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;
  const { forms, formValues, handleSubmit, disabled, companyId, isLoading } =
    useCompanyFormContext();
  const [form] = Form.useForm<CompanyReportFormValues>(forms.companyReport);
  const { data, isLoading: configLoading } = useCompanyReportConfig(
    companyId.toString(),
  );

  useEffect(() => {
    if (!formValues.companyReport && data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      baseKey={companyId.toString()}
      basePath={`/app/registry/companies/${companyId}`}
      route={route.parent}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSubmit}
          disabled={disabled || isLoading}
          block
        >
          {intl({ id: 'commons.entity.save' })}
        </SaveButton>
      }
    >
      <Skeleton loading={configLoading}>
        <CompaniesReportForm form={form} />
      </Skeleton>

      <CompanyFooter disabled={disabled} />
    </DefaultRouteTabs>
  );
};

export default CompanyReportPage;
